var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-list-item-avatar',{attrs:{"icon":"","color":_vm.color,"size":_vm.size},on:{"click":function($event){return _vm.$emit('click')}}},[_c('v-img',{attrs:{"contain":"","src":_vm.src,"height":_vm.imageSize}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }